import { render } from "./ProposalCounterSection.vue?vue&type=template&id=401373f9&scoped=true"
import script from "./ProposalCounterSection.vue?vue&type=script&lang=js"
export * from "./ProposalCounterSection.vue?vue&type=script&lang=js"

import "./ProposalCounterSection.vue?vue&type=style&index=0&id=401373f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401373f9"]])

export default __exports__